import { useSelector, shallowEqual } from 'react-redux';
import { createSelector } from 'reselect';
import { getAllLearningJourneys } from '../../containers/upf-assign/upf-assign-util';

const useLearningJourneys = (standardName, options) => {
  const getLearningJourneyIds = createSelector(
    state => state.UPFAssignReducer.selectedTopics,
    (topics) => {
      let ljs = [];
      if (topics?.length) {
        if (standardName) {
          ljs = topics.find(topic =>
            topic?.selected && topic?.childTopics.find(childTopic => (childTopic.name === standardName)))?.childTopics;
        } else {
          ljs = getAllLearningJourneys(topics);
        }
        if (options?.id) {
          return ljs?.length ? ljs.find(lj => lj.name === standardName)?.childTopics.map(lj => lj.id) : [];
        }
      }
      return ljs;
    }

  );
  const learningJourneys = useSelector(getLearningJourneyIds, shallowEqual);

  return learningJourneys || [];
};

export default useLearningJourneys;
